// pages/ServicioManual.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ServicioManual.css';

const ServicioManual = () => {
  const token = useSelector(state => state.auth.token);
  const decoded = token ? jwtDecode(token) : {};
  const estacionUsuario = decoded.estacion?.trim().toUpperCase() || 'SIN ESTACIÓN';
  const user = JSON.parse(localStorage.getItem('user')) || {};

  const [formData, setFormData] = useState({
    fechaInput: new Date().toISOString().split('T')[0],
    estacion: estacionUsuario,
    usuarioInicio: user.noColaborador || 'SISTEMA',
    motivo: '',
    tipoServicio: '',
    aerolinea: '',
    noVuelo: '',
    noColaborador: '',
    nombrePax: '',
    noAsiento: '',
    tipoSilla: '',
    observaciones: 'CAPTURA MANUAL AUTOMÁTICAMENTE',
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [searchColaborador, setSearchColaborador] = useState('');
  const [errores, setErrores] = useState({});

  const abrirModalAsignar = async () => {
    setIsModalOpen(true);
    try {
      const response = await axios.get('https://orionadministracion.com/api/bitacora/en-turno-detalles', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const filtrados = response.data.filter(col => col.estacion?.trim().toUpperCase() === estacionUsuario);
      setColaboradores(filtrados);
    } catch (err) {
      console.error(err);
      toast.error("Error al obtener colaboradores");
    }
  };

  const seleccionarColaborador = (colaborador) => {
    setFormData(prev => ({ ...prev, noColaborador: colaborador.noColaborador }));
    setIsModalOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrores(prev => ({ ...prev, [name]: false }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const camposObligatorios = ['motivo', 'tipoServicio', 'aerolinea', 'noVuelo', 'noColaborador', 'nombrePax', 'noAsiento', 'tipoSilla'];
    const nuevosErrores = {};
    camposObligatorios.forEach(campo => {
      if (!formData[campo]) nuevosErrores[campo] = true;
    });

    if (Object.keys(nuevosErrores).length > 0) {
      setErrores(nuevosErrores);
      toast.warning("Completa todos los campos requeridos");
      return;
    }

    try {
      await axios.post('https://orionadministracion.com/api/servicios', formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Servicio manual registrado");
      setTimeout(() => window.location.reload(), 2000);
    } catch (err) {
      console.error(err);
      toast.error("Error al registrar el servicio");
    }
  };

  const filteredColaboradores = colaboradores.filter(col =>
    col.siglas?.toLowerCase().includes(searchColaborador.toLowerCase())
  );

  return (
    <div className="manual-service-page">
      <ToastContainer />
      <h1>Registro Manual de Servicio</h1>
      <form className="manual-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Motivo</label>
          <select name="motivo" value={formData.motivo} onChange={handleChange} className={errores.motivo ? 'error-input' : ''}>
            <option value="">Seleccione una opción</option>
            <option>SIN PASE</option>
            <option>UH</option>
            <option>SILLA PROPIA</option>
          </select>
        </div>

        <div className="form-group">
          <label>Tipo</label>
          <select name="tipoServicio" value={formData.tipoServicio} onChange={handleChange} className={errores.tipoServicio ? 'error-input' : ''}>
            <option value="">Seleccione una opción</option>
            <option>LLEGADAS</option>
            <option>SALIDAS</option>
          </select>
        </div>

        <div className="form-group">
          <label>Aerolínea</label>
          <input name="aerolinea" value={formData.aerolinea} onChange={handleChange} className={errores.aerolinea ? 'error-input' : ''} />
        </div>

        <div className="form-group">
          <label>Número de Vuelo</label>
          <input name="noVuelo" value={formData.noVuelo} onChange={handleChange} className={errores.noVuelo ? 'error-input' : ''} />
        </div>

        <div className="form-group">
          <label>Asignar a</label>
          <input readOnly value={formData.noColaborador} className={errores.noColaborador ? 'error-input' : ''} />
          <button type="button" onClick={abrirModalAsignar} className="btn-camera">Asignar</button>
        </div>

        <div className="form-group">
          <label>Nombre Pax</label>
          <input name="nombrePax" value={formData.nombrePax} onChange={handleChange} className={errores.nombrePax ? 'error-input' : ''} />
        </div>

        <div className="form-group">
          <label>No. Asiento</label>
          <input name="noAsiento" value={formData.noAsiento} onChange={handleChange} className={errores.noAsiento ? 'error-input' : ''} />
        </div>

        <div className="form-group">
          <label>Tipo de Silla</label>
          <select name="tipoSilla" value={formData.tipoSilla} onChange={handleChange} className={errores.tipoSilla ? 'error-input' : ''}>
            <option value="">Seleccione una opción</option>
            <option>ESTANDAR</option>
            <option>WCHC</option>
            <option>UH</option>
            <option>SILLA PROPIA</option>
          </select>
        </div>

        <div className="form-group">
          <label>Observaciones</label>
          <input name="observaciones" value={formData.observaciones} readOnly />
        </div>

        <button type="submit" className="btn-submit">Registrar Servicio</button>
      </form>

      {/* Modal de Colaboradores */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <input
              type="text"
              placeholder="Buscar por siglas"
              value={searchColaborador}
              onChange={(e) => setSearchColaborador(e.target.value)}
            />
            <ul className="colaboradores-list">
              {filteredColaboradores.map(col => (
                <li key={col.noColaborador} onClick={() => seleccionarColaborador(col)}>
                  {col.siglas} - {col.nombreCompleto}
                </li>
              ))}
            </ul>
            <button className="btn-close" onClick={() => setIsModalOpen(false)}>Cerrar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServicioManual;
